import React, { ReactElement } from 'react';
import { SideSubNavigationGroupTitleProps } from './group-title.types';
import { useStyles } from './group-title.style';

export function GroupTitle({ children }: SideSubNavigationGroupTitleProps): ReactElement {
	const { classes } = useStyles();
	return <div className={classes.root}>{children}</div>;
}
